import { render, staticRenderFns } from "./password_trans.vue?vue&type=template&id=26470acf"
import script from "./password_trans.vue?vue&type=script&lang=js"
export * from "./password_trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports